import React, { useState, useRef, useEffect } from 'react';
import { ChevronDown, LogOut, Users } from 'lucide-react';
import { getProfiles, getActiveProfile, setActiveProfile, clearActiveProfile } from '../../utils/profileManager';
import { playSound } from '../../utils/soundManager';

const ProfileSwitcher = ({ currentProfile, onProfileChange, onLogout, onManageProfiles }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [profiles, setProfiles] = useState([]);
  const dropdownRef = useRef(null);

  useEffect(() => {
    setProfiles(getProfiles());
  }, [currentProfile]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleToggle = () => {
    playSound('click');
    setIsOpen(!isOpen);
  };

  const handleSwitchProfile = (profile) => {
    playSound('click');
    setActiveProfile(profile.id);
    onProfileChange(profile);
    setIsOpen(false);
  };

  const handleLogout = () => {
    playSound('click');
    clearActiveProfile();
    onLogout();
    setIsOpen(false);
  };

  const handleManageProfiles = () => {
    playSound('click');
    onManageProfiles();
    setIsOpen(false);
  };

  if (!currentProfile) return null;

  return (
    <div className="profile-switcher" ref={dropdownRef}>
      <button
        className="profile-switcher-button hover-scale btn-press"
        onClick={handleToggle}
        style={{ borderColor: currentProfile.color }}
      >
        <div className="profile-switcher-avatar" style={{ background: currentProfile.color }}>
          <span>{currentProfile.avatar}</span>
        </div>
        <div className="profile-switcher-info">
          <span className="profile-switcher-name">{currentProfile.name}</span>
          <span className="profile-switcher-age">Age {currentProfile.age}</span>
        </div>
        <ChevronDown
          size={20}
          className={`profile-switcher-icon ${isOpen ? 'rotated' : ''}`}
        />
      </button>

      {isOpen && (
        <div className="profile-switcher-dropdown animate-scaleIn">
          <div className="dropdown-section">
            <div className="dropdown-header">Switch Profile</div>
            {profiles
              .filter(p => p.id !== currentProfile.id)
              .map((profile) => (
                <button
                  key={profile.id}
                  className="dropdown-item profile-item hover-lift"
                  onClick={() => handleSwitchProfile(profile)}
                >
                  <div className="dropdown-profile-avatar" style={{ background: profile.color }}>
                    <span>{profile.avatar}</span>
                  </div>
                  <div className="dropdown-profile-info">
                    <span className="dropdown-profile-name">{profile.name}</span>
                    <span className="dropdown-profile-age">Age {profile.age}</span>
                  </div>
                </button>
              ))}
          </div>

          <div className="dropdown-divider"></div>

          <div className="dropdown-section">
            <button
              className="dropdown-item hover-lift"
              onClick={handleManageProfiles}
            >
              <Users size={18} />
              <span>Manage Profiles</span>
            </button>
            <button
              className="dropdown-item logout-item hover-lift"
              onClick={handleLogout}
            >
              <LogOut size={18} />
              <span>Logout</span>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProfileSwitcher;
